import { useEffect, useRef, useState } from "react";
import { Container } from "./style";
import { FaqApi } from "../../api/Faq.api";
import Faq from "../../models/Faq.model";
import FaqItem from "../../components/home/Faq.item";
import Notice from "../../models/Notice.model";
import { NoticeApi } from "../../api/Notice.api";
import { VideoApi } from "../../api/Video.api";
import Video from "../../models/Video.model";
import NoticeItem from "../../components/home/Notice.item";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import { isMobile } from "react-device-detect";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../store";
import Youtube from "react-youtube";
import { Rating } from "@mui/material";
import StarRoundedIcon from '@mui/icons-material/StarRounded';
import StarBorderRoundedIcon from '@mui/icons-material/StarBorderRounded';
import { HomeVideoApi } from "../../api/HomeVideo.api";
import HomeVideo from "../../models/HomeVideo.model";
import { ReviewApi } from "../../api/Review.api";
import Review from "../../models/Review.model";
import ReviewItem from "../../components/review/Review.item";
import moment from "moment";

export default function HomePage() {

  const navigate = useNavigate()

  const user = useAppSelector(state => state.app.user)

  const [homeVideoList, setHomeVideoList] = useState<HomeVideo[]>([])
  const [selectedHomeVideo, setSelectedHomeVideo] = useState<HomeVideo>()

  const [videoList, setVideoList] = useState<Video[]>([])
  const [selectedVideo, setSelectedVideo] = useState<Video>()

  const [reviewList, setReviewList] = useState<Review[]>([])
  const [noticeList, setNoticeList] = useState<Notice[]>([])
  const [faqList, setFaqList] = useState<Faq[]>([])

  const [screenWidth, setScreenWidth] = useState(window.innerWidth)
  const [isMobile, setIsMobile] = useState(false)
  
  const productRef = useRef<HTMLDivElement>(null);
  const [productItem, setProductItem] = useState(0)
  
  const [selectedReview, setSelectedReview] = useState<Review>()


  useEffect(() => {
    getHomeVideoList()
    getFaqList()
    getVideoList()
    getNoticeList()
    getReviewList()

    const handleResize = () => {
      setScreenWidth(window.innerWidth)
    }

    window.addEventListener("resize", handleResize);

  }, [])

  useEffect(() => {
    if(screenWidth < 501) {
      setIsMobile(true)
    } else{
      setIsMobile(false)
    }
  }, [screenWidth])

  useEffect(() => {
    if((selectedHomeVideo !== undefined) && (selectedVideo !== undefined) && (selectedReview !== undefined)) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [selectedHomeVideo, selectedVideo, selectedReview])

  const getFaqList = () => {
    FaqApi.list({page: 1, pageSize: 1000})
    .then(result => {
      setFaqList(result.results)
    }).catch(console.error)
  }

  const getNoticeList = () => {
    NoticeApi.list({page: 1, pageSize: 1000})
    .then(result => {
      setNoticeList(result.results)
    }).catch(console.error)
  }

  const getVideoList = () => {
    VideoApi.list({page: 1, pageSize: 1000})
    .then(result => {
      setVideoList(result.results)
    }).catch(console.error)
  }

  const getHomeVideoList = () => {
    HomeVideoApi.list()
    .then(result => {
      setHomeVideoList(result.results)
    }).catch(console.error)
  }

  const getReviewList = () => {

    ReviewApi.list({page:1, pageSize: 1000})
    .then(result => {
      setReviewList(result.results)
    }).catch(console.error)

  }

  return (
    <Container className="home">
      <section className="intro">
        <div className="bg_img">
          <div className="inner flex column ai-s">
            <strong className="sub_text">지식재산권 걱정 없이, 사업만 열심히 하시라고</strong>
            <strong className="extra">셀러 안심 서비스</strong>
            <strong className="extra green">셀러가드</strong>
            <div>
              <strong className="extra black29">월 자문료</strong>
              <strong className="extra green">5만원</strong>
              <strong className="gray_9a">(VAT 별도)</strong>
            </div>
            <img src="/images/intro_banner_mobile.png" alt="banner" className="mobile_banner_img" />
            <button className="contained_main"
              onClick={() => {
                if(user === undefined) return
                if(user === null) navigate('/signin')
                else {
                  if(user.subscriptionList.find(v => v.deletedAt === null)) {
                    navigate('/apply')
                  }
                  else {
                    navigate('/subscription')
                  }
                }
              }}
            >
              <strong>지금 구독신청하기</strong>
            </button>
          </div>
        </div>
      </section>

      <section className="how">
        <div className="inner">
          <strong className="section_head extra">
            <span className="green">셀러가드</span>는<br />어떻게 진행 되나요?
          </strong>
          
          <ul className="step_list">
            {/* <div className="left"></div>
            <ul className="right">
              {homeVideoList.map((item, index) => (
                <li key={`item${index}`}>
                  <img src="" alt={item.title} />
                </li>
              ))}
            </ul> */}

            <li className="step_item">
              <strong className="step extra">이메일</strong>
              <div className="right">
                <div className="img_bx">
                  <img src="/images/law_white.png" alt="법률 상담" />
                </div>
                <div className="txt_bx">
                  <strong className="title extra">법률 상담</strong>
                  <p className="gray_9a">관련 법률과 최신 판례에 비추어 셀러의 판매 행위가<br/>과연 법에 위반되는지 분석합니다.</p>
                </div>
                {!isMobile && (
                  <button className="btn_youtube_video"
                    onClick={() => setSelectedHomeVideo(homeVideoList.find(v => v.title === '법률 상담'))}
                  >
                    <img className="youtube" src="images/ico-youtube@3x.png" alt="video" />
                  </button>
                )}
              </div>
            </li>
            
            <li className="step_item">
              <strong className="step extra">내용증명</strong>
              <div className="right">
                <div className="img_bx">
                  <img src="/images/stamp_white.png" alt="내용증명 대응" />
                </div>
                <div className="txt_bx">
                  <strong className="title extra">내용증명 대응</strong>
                  <p className="gray_9a">법무법인(유한) 강남 이름으로 내용증명에 대한<br/>답장을 발송합니다.</p>
                </div>
                {!isMobile && (
                  <button className="btn_youtube_video"
                    onClick={() => setSelectedHomeVideo(homeVideoList.find(v => v.title === '내용증명 대응'))}
                  >
                    <img className="youtube" src="images/ico-youtube@3x.png" alt="video" />
                  </button>
                )}
              </div>
            </li>
            
            <li className="step_item">
              <strong className="step extra">형사고소</strong>
              <div className="right">
                <div className="img_bx">
                  <img src="/images/judge_white.png" alt="승소가능성 판단" />
                </div>
                <div className="txt_bx">
                  <strong className="title extra">승소가능성 판단</strong>
                  <p className="gray_9a">법무법인(유한) 강남의 승소 사례에 비추어, 사건이<br/>민·형사 절차로 진행시 승소 가능성을 판단합니다.</p>
                </div>
                {!isMobile && (
                  <button className="btn_youtube_video"
                    onClick={() => setSelectedHomeVideo(homeVideoList.find(v => v.title === '승소가능성 판단'))}
                  >
                    <img className="youtube" src="images/ico-youtube@3x.png" alt="video" />
                  </button>
                )}
              </div>
            </li>
            
            <li className="step_item">
              <strong className="step extra">경찰조사</strong>
              <ul>
                <li className="right">
                  <div className="img_bx">
                    <img src="/images/note_white.png" alt="경찰 조사용 의견서 제공" />
                  </div>
                  <div className="txt_bx">
                    <strong className="title extra">경찰 조사용 의견서 제공</strong>
                    <p className="gray_9a">승소 사례로 검증된 경찰 조사용 의견서를<br/>제공해 드립니다.</p>
                  </div>
                  {!isMobile && (
                    <button className="btn_youtube_video"
                      onClick={() => setSelectedHomeVideo(homeVideoList.find(v => v.title === '경찰 조사용 의견서 제공'))}
                    >
                      <img className="youtube" src="images/ico-youtube@3x.png" alt="video" />
                    </button>
                  )}
                </li>
                <li className="right">
                  <div className="img_bx">
                    <img src="/images/info_white.png" alt="승소사례 정보 제공" />
                  </div>
                  <div className="txt_bx">
                    <strong className="title extra">승소사례 정보 제공</strong>
                    {isMobile ? <p className="gray_9a">법무법인(유한) 강남이 직접 수행한 사건의 불송치<br/>의견서(무혐의), 불기소 이유서(무혐의)를<br/>수사기관에 제출해 드립니다.</p> : <p className="gray_9a">법무법인(유한) 강남이 직접 수행한 사건의 불송치 의견서(무혐의),<br/>불기소 이유서(무혐의)를 수사기관에 제출해 드립니다.</p>}
                  </div>
                  {!isMobile && (
                    <button className="btn_youtube_video"
                      onClick={() => setSelectedHomeVideo(homeVideoList.find(v => v.title === '승소사례 정보 제공'))}
                    >
                      <img className="youtube" src="images/ico-youtube@3x.png" alt="video" />
                    </button>
                  )}
                </li>
                <li className="right">
                  <div className="img_bx">
                    <img src="/images/police_white.png" alt="경찰 조사 시뮬레이션" />
                  </div>
                  <div className="txt_bx">
                    <strong className="title extra">경찰 조사 시뮬레이션</strong>
                    <p className="gray_9a">변호사가 직접 경찰 조사 시뮬레이션을 통해 진술 내용과<br/>태도를 점검해 드립니다.</p>
                  </div>
                  {!isMobile && (
                    <button className="btn_youtube_video"
                      onClick={() => setSelectedHomeVideo(homeVideoList.find(v => v.title === '경찰 조사 시뮬레이션'))}
                    >
                      <img className="youtube" src="images/ico-youtube@3x.png" alt="video" />
                    </button>
                  )}
                </li>
              </ul>
            </li>
            
            <li className="step_item">
              <strong className="step extra">재 판</strong>
              <div className="right">
                <div className="img_bx">
                  <img src="/images/contract_white.png" alt="재판용 의견서 제공" />
                </div>
                <div className="txt_bx">
                  <strong className="title extra">재판용 의견서 제공</strong>
                  <p className="gray_9a">수많은 사건 수행 경험으로 최적화된 형사 의견서,<br/>민사 답변서를 제공해 드립니다.</p>
                </div>
                {!isMobile && (
                  <button className="btn_youtube_video"
                    onClick={() => setSelectedHomeVideo(homeVideoList.find(v => v.title === '민사 답변서 제공'))}
                  >
                    <img className="youtube" src="images/ico-youtube@3x.png" alt="video" />
                  </button>
                )}
              </div>
            </li>
          </ul>
        </div>

        {selectedHomeVideo && (
          <div className="modal video">
            <div className="box">
              <button
                onClick={() => setSelectedHomeVideo(undefined)}
              />
              <Youtube
                videoId={selectedHomeVideo.videoId}
                opts={{
                  // width: '780',
                  height: isMobile ? '320' : '520',
                  playerVars: {
                    autoplay: 1
                  }
                }}
              />
            </div>
          </div>
        )}
      </section>

      <section className="service">
        <div className="inner">
          <div className="wrap flex">
            <div className="column_title">
              <p className="type">종류</p>
              <p className="price">금액</p>
              <p className="standard">제공 기준</p>
              <p className="title_green">서비스 내용 및 비용 (VAT 별도)</p>
              <p className="service_item item_ttl">법률 상담</p>
              <p className="service_item item_ttl">내용증명 대응</p>
              <div className="service_item">
                <p className="item_ttl">경찰 조사용<br/>의견서 제공</p>
                <div>
                  <p>구독 <br/>6개월 <br/>미만</p>
                  <p>구독 <br/>12개월 <br/>미만</p>
                  <p>구독 <br/>12개월 <br/>이상</p>
                </div>
              </div>
              <div className="service_item">
                <p className="item_ttl">승소사례<br/>제공</p>
                <div>
                  <p>구독 <br/>6개월 <br/>미만</p>
                  <p>구독 <br/>12개월 <br/>미만</p>
                  <p>구독 <br/>12개월 <br/>이상</p>
                </div>
              </div>
              <div className="service_item">
                <p className="item_ttl">재판용<br/>의견서<br/>제공</p>
                <div>
                  <p>구독 <br/>6개월 <br/>미만</p>
                  <p>구독 <br/>12개월 <br/>미만</p>
                  <p>구독 <br/>18개월 <br/>미만</p>
                  <p>구독 <br/>24개월 <br/>미만</p>
                  <p>구독 <br/>24개월 <br/>이상</p>
                </div>
              </div>
              <div className="service_item">
                <p className="item_ttl">시뮬레이션</p>
                <div>
                  <p>구독 <br/>6개월 <br/>미만</p>
                  <p>구독 <br/>12개월 <br/>미만</p>
                  <p>구독 <br/>18개월 <br/>미만</p>
                  <p>구독 <br/>18개월 <br/>이상</p>
                </div>
              </div>
            </div>

            <div className="column_cont flex1" ref={productRef}>
              {isMobile && (
                <div className="arrow_btn_group">
                  <button
                    className="btn_prev"
                    onClick={() => setProductItem(productItem-1)}
                    disabled={productItem === 0}
                  />

                  <button
                    className="btn_next"
                    onClick={() => setProductItem(productItem+1)}
                    disabled={productItem === 2}
                  />
                </div>
              )}
              <div className="cont_wrap flex"
                // style={{
                //   transform: `translateX(-${productItemPosition}px)`
                // }}
              >
                {(!isMobile || (isMobile && productItem === 0)) && (
                  <div className="column_group">
                    <p className="type">정기자문료</p>
                    <div className="price">
                      <p>월 <strong className="extra green">5만원</strong></p>
                      <p className="gray_9a">(VAT 별도)</p>
                    </div>
                    <div className="standard">
                      <p>정기자문료</p>
                      <p>구독일로부터 <strong className="green">2개월 도과</strong></p>
                    </div>
                    <p>무료</p>
                    <p>무료</p>

                    <p>10만원</p>
                    <p>5만원</p>
                    <p>무료</p>

                    <p>10만원</p>
                    <p>5만원</p>
                    <p>무료</p>

                    <p>20만원</p>
                    <p>15만원</p>
                    <p>10만원</p>
                    <p>5만원</p>
                    <p>무료</p>

                    <p>40만원</p>
                    <p>30만원</p>
                    <p>20만원</p>
                    <p>10만원</p>
                  </div>
                )}

                {(!isMobile || (isMobile && productItem === 1)) && (
                  <div className="column_group">
                    <p className="type">특별자문료</p>
                    <div className="price">
                      <p>1회 <strong className="extra green">90만원</strong></p>
                      <p className="gray_9a">(VAT 별도)</p>
                    </div>
                    <div className="standard">
                      <p>구독일로부터</p>
                      <strong className="green">2개월 도과 전</strong>
                      <p>서비스 제공 원할 경우</p>
                      <br/>
                      <p>특별자문료 납부 1개월 후부터</p>
                      <strong className="green">정기자문료 자동결제</strong>
                    </div>
                    <p>무료</p>
                    <p>무료</p>
                    
                    <p>무료</p>
                    <p>무료</p>
                    <p>무료</p>
                    
                    <p>무료</p>
                    <p>무료</p>
                    <p>무료</p>
                    
                    <p>무료</p>
                    <p>무료</p>
                    <p>무료</p>
                    <p>무료</p>
                    <p>무료</p>
                    
                    <p>무료</p>
                    <p>무료</p>
                    <p>무료</p>
                    <p>무료</p>

                  </div>
                )}

                {(!isMobile || (isMobile && productItem === 2)) && (
                  <div className="column_group">
                    <p className="type">비구독시</p>
                    <p className="price">-</p>
                    <p className="standard">정기/특별 자문료를<br/>납부하지 않은 경우,<br/>아래 금액에 따라<br/>서비스 제공</p>
                    <p>50만원</p>
                    <p>50만원</p>

                    <p>100만원</p>
                    <p>100만원</p>
                    <p>100만원</p>

                    <p>100만원</p>
                    <p>100만원</p>
                    <p>100만원</p>

                    <p>100만원</p>
                    <p>100만원</p>
                    <p>100만원</p>
                    <p>100만원</p>
                    <p>100만원</p>

                    <p>300만원</p>
                    <p>300만원</p>
                    <p>300만원</p>
                    <p>300만원</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="video">
        <div className="inner">
          <Slider
            {...{
              // dots: true,
              infinite: true,
              speed: 500,
              slidesToShow: isMobile ? 1 : 2,
              slidesToScroll: isMobile ? 1 : 2
            }}
            >
              {videoList.map((video, index) => (
                <div key={`video${index}`} className="video_item"
                  onClick={() => setSelectedVideo(video)}
                >
                  <img src={`${process.env.REACT_APP_IMAGE_URL}thumbnail/${video.thumbnail}`} alt="" />
                  <img className="icon" src="images/ico-youtube@3x.png" alt="video" />
                </div>
              ))}
          </Slider>
        </div>

        {selectedVideo && (
          <div className="modal video">
            <div className="box">
              <button
                onClick={() => setSelectedVideo(undefined)}
              />
              <Youtube
                videoId={selectedVideo.videoId}
                opts={{
                  // width: '780',
                  height: isMobile ? '320' : '520',
                  playerVars: {
                    autoplay: 1
                  }
                }}
              />
            </div>
          </div>
        )}
      </section>
      
      {reviewList.length !== 0 && (
        <section className="review">
          <div className="inner">
            <Slider
              {...{
                infinite: true,
                speed: 500,
                slidesToShow: (isMobile || reviewList.length < 3) ? 1 : 3,
                slidesToScroll: isMobile ? 1 : 3
              }}
              >
                {reviewList.map((review, index) => (
                  <div
                    key={`review${index}`}
                    onClick={() => setSelectedReview(review)}
                  >
                    <ReviewItem
                      key={`reivew${index}`}
                      review={review}
                      ellipsisHeight={97}
                    />
                  </div>
                ))}
            </Slider>
          </div>

          {selectedReview && (
            <section className="modal review">
              <div className="card"
                onClick={() => {
                  navigate('/review')
                }}
              >
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedReview(undefined)
                  }}
                />

                <p className="title">{selectedReview.name} 님의 소중한 리뷰</p>
                <p className="gray_9a">{moment(selectedReview.createdAt).format('YYYY-MM-DD')}</p>
                <Rating
                  value={selectedReview.rating}
                  readOnly
                  precision={0.5}
                  icon={<StarRoundedIcon />}
                  emptyIcon={<StarBorderRoundedIcon />}
                />
                <p className="cont gray_9a">{selectedReview.description}</p>
              </div>
            </section>
          )}
        </section>
      )}
      
      <section className="contact">
        <div className="inner">
          <strong className="section_head extra">
            지금 바로<br />
            <span className="green">셀러가드</span>를 만나보세요
          </strong>
          <ul className="flex">
            <li className="card flex1 flex column"
              onClick={() => {
                if(!isMobile) navigate('/advise')
                else document.location.href = 'tel:010-8415-0997'
              }}
            >
              <img src="/images/contact1.png" alt="구독상담 신청하기" />
              <strong className="extra">구독상담 신청하기</strong>
            </li>
            <li className="card flex1 flex column"
              onClick={() => {
                if(user === undefined) return
                if(user === null) navigate('/signin')
                else {
                  if(user.subscriptionList.find(v => v.deletedAt === null)) {
                    navigate('/apply')
                  }
                  else {
                    navigate('/subscription')
                  }
                }
              }}
            >
              <img src="/images/contact2.png" alt="법률자문 구독하기" />
              <strong className="extra">법률자문 구독하기</strong>
            </li>
            <li className="card flex1 flex column"
              onClick={() => {
                if(user === undefined) return
                if(user === null) navigate('/signin')
                else {
                  if(user.subscriptionList.find(v => v.deletedAt === null)) {
                    navigate('/apply')
                  }
                  else {
                    navigate('/subscription')
                  }
                }
              }}
            >
              <img src="/images/contact3.png" alt="법률자문 신청하기" />
              <strong className="extra">법률자문 신청하기</strong>
            </li>
          </ul>
        </div>
      </section>

      <section className="notice">
        <div className="inner">
          <strong className="section_head extra">공지사항</strong>
          <ul className="faq_list">
            {noticeList.map((notice, index) => (
              <NoticeItem
                key={`notice${index}`}
                notice={notice}
              />
            ))}
          </ul>
        </div>
      </section>
      
      <section className="faq">
        <div className="inner">
          <strong className="section_head extra">자주 묻는 질문</strong>

          <ul className="faq_list">
            {faqList.map((faq, index) => (
              <FaqItem
                key={`faq${index}`}
                faq={faq}
              />
            ))}
          </ul>
        </div>
      </section>
    </Container>
  )
}